import { Inject } from '@angular/core';
import '@angular/compiler';
import { PageReportsComponent } from './page.reports/page.reports.component';
import { PageAiReviewComponent } from './page.ai.review/page.ai.review.component';
import { PageVillagesComponent } from './page.villages/page.villages.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PageMissionsComponent } from './page.missions/page.missions.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NuMonacoEditorModule } from '@ng-util/monaco-editor';
import { SortablejsModule } from "src/libs/portal/season/ngx-sortablejs";
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
    constructor(@Inject( DomSanitizer) private domSanitizer: DomSanitizer) { }
    transform(url) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}

// translate libs
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { HttpClient, HttpClientModule } from '@angular/common/http';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/lang/', '.json');
}

// initialize ng module
@NgModule({
    declarations: [
        SafePipe,
        AppComponent,
        PageReportsComponent,
        PageAiReviewComponent,
        PageVillagesComponent,
        LayoutEmptyComponent,
        PortalSeasonModalComponent,
        PortalPostListComponent,
        PortalSeasonPaginationComponent,
        PortalPostDetailComponent,
        LayoutSidebarComponent,
        PageDashboardComponent,
        PortalSeasonFormDropdownComponent,
        PortalSeasonTreeComponent,
        PortalSeasonLoadingSeasonComponent,
        PageAccessComponent,
        PageMissionsComponent,
        PortalSeasonLoadingDefaultComponent,
        PageMypageComponent,
        ComponentNavSidebarComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        SortablejsModule,
        KeyboardShortcutsModule.forRoot(),
        NuMonacoEditorModule.forRoot({ baseUrl: `lib` }),
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        }),
        
    ],
    providers: [
        {
            provide: COMPOSITION_BUFFER_MODE,
            useValue: false
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }